import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { stringHasher } from "./stringHasher";
export var getChecksum = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(body, _ref) {
    var checksumAlgorithmFn, base64Encoder;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            checksumAlgorithmFn = _ref.checksumAlgorithmFn, base64Encoder = _ref.base64Encoder;
            _context.t0 = base64Encoder;
            _context.next = 4;
            return stringHasher(checksumAlgorithmFn, body);
          case 4:
            _context.t1 = _context.sent;
            return _context.abrupt("return", (0, _context.t0)(_context.t1));
          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function getChecksum(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();